import { render, staticRenderFns } from "./QLVNBomb.vue?vue&type=template&id=2701b5b4&scoped=true"
import script from "./QLVNBomb.vue?vue&type=script&lang=js"
export * from "./QLVNBomb.vue?vue&type=script&lang=js"
import style0 from "./QLVNBomb.vue?vue&type=style&index=0&id=2701b5b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2701b5b4",
  null
  
)

export default component.exports